import React, {useState} from 'react';

import {Header} from '@/components';
import type {AppDistributionRelease} from '@/types/FirebaseAppDistribution';
import {AppPlatform} from '@/types/FirebaseAppDistribution';

import AppReleasesTable from './AppReleasesTable';
import PlatformSelector from './PlatformSelector';
import ReleaseDetailsModal from './ReleaseDetailsModal';

const AppReleasesPage: React.FC = () => {
  const [currentPlatform, setCurrentPlatform] = useState<AppPlatform>(
    AppPlatform.IOS,
  );
  const [selectedRelease, setSelectedRelease] =
    useState<AppDistributionRelease | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handlePlatformChange = (platform: AppPlatform) => {
    setCurrentPlatform(platform);
  };

  const handleReleaseSelect = (release: AppDistributionRelease) => {
    setSelectedRelease(release);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedRelease(null);
  };

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title="App Releases" />

      <div className="mt-6 space-y-6">
        {/* Platform Selector */}
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div>
            <h2 className="text-lg font-medium text-gray-900 dark:text-white">
              Firebase App Distribution Releases
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              Download APK and IPA files for mobile app releases
            </p>
          </div>
          <PlatformSelector
            currentPlatform={currentPlatform}
            onPlatformChange={handlePlatformChange}
          />
        </div>

        {/* Releases Table */}
        <div className="bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-200 dark:border-gray-600">
          <div className="p-6">
            <AppReleasesTable
              platform={currentPlatform}
              onReleaseSelect={handleReleaseSelect}
            />
          </div>
        </div>
      </div>

      {/* Release Details Modal */}
      <ReleaseDetailsModal
        release={selectedRelease}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </main>
  );
};

export default AppReleasesPage;
